<template>
  <div>
    <v-img
      :src="URL_LOGO_LANDSCAPE"
      alt="Crossref logo"
      max-height="50px"
      max-width="100px"
      min-height="36px"
      min-width="100px"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { URL_LOGO_LANDSCAPE } from '@/constants/urls';

export default defineComponent({
  name: 'AppLogoWorkmark',
  setup() {
    return {
      // This is deliberately not reactive, as it won't change dynamically
      URL_LOGO_LANDSCAPE,
    };
  },
});
</script>

<style scoped>

</style>
